import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=4a934f6a"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=4a934f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports